export default __webpack_public_path__ + "static/media/j-logo.073ea8f3.png";